import {
  Arrange,
  Button,
  Container,
  Spacer,
  SvgExternalLink,
  Text,
} from '@loomhq/lens';
import React from 'react';

import {
  COMPLETED_ONBOARDING_STEP,
  EXTENSION_INSTALL_CLICKED,
} from 'constants/events';
import { SLACKID_ONBOARDING_MODAL } from 'constants/onboarding';
import { CHROME_EXT_WEBSTORE_URL } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import { getSupportedPlatformType } from 'utilities/download-desktop';

import DownloadDesktopButton, {
  BUTTON_TYPE_TEXT,
} from 'components/download-desktop-button';
import { DOWNLOAD_OPTIONS_STEP } from 'components/welcome-webapp-simplified/constants';

function DownloadStep({ handleNextStep, markOnboardingCompleteLoading }) {
  const platform = getSupportedPlatformType();

  function handleClose() {
    analytics.track(COMPLETED_ONBOARDING_STEP, {
      step: DOWNLOAD_OPTIONS_STEP,
      action: 'download-click',
      platform,
      source: SLACKID_ONBOARDING_MODAL,
    });

    handleNextStep();
  }

  return (
    <>
      <Text size="large" fontWeight="bold">
        You&apos;re set! Download Loom.
      </Text>
      <Spacer bottom="medium" />
      <Container borderSide="all" radius="medium" padding="medium">
        <Text size="medium" fontWeight="bold">
          Chrome extension
        </Text>
        <Spacer bottom="small" />
        <Text size="small">
          Record directly from your browser and unlock integrations like Gmail
          and Jira.
        </Text>
        <Spacer bottom="small" />
        <Button
          variant="primary"
          htmlTag="a"
          target="_blank"
          href={CHROME_EXT_WEBSTORE_URL}
          icon={<SvgExternalLink />}
          iconPosition="left"
          onClick={() => {
            analytics.track(EXTENSION_INSTALL_CLICKED, {
              where: window.location.pathname.replace('/', ''),
              source: SLACKID_ONBOARDING_MODAL,
            });

            handleClose();
          }}
        >
          <Text size="small">Install Chrome Extension</Text>
        </Button>
        <Spacer bottom="xsmall" />
      </Container>
      <Spacer bottom="small" />

      <Arrange gap="0">
        <Text>or</Text>
        <DownloadDesktopButton
          hideIcon={true}
          buttonType={BUTTON_TYPE_TEXT}
          buttonText="download the desktop app"
          afterOnClick={() => {
            analytics.track('"Finish Installing" Click', {
              platform,
              source: SLACKID_ONBOARDING_MODAL,
            });

            handleClose();
          }}
        />
      </Arrange>

      <Spacer bottom="medium" />

      <div className="flex justify:flexEnd">
        <Button
          onClick={handleClose}
          hasLoader={markOnboardingCompleteLoading}
          isDisabled={markOnboardingCompleteLoading}
        >
          Close
        </Button>
      </div>
    </>
  );
}

export default DownloadStep;
